import { createStore } from "vuex";

export default createStore({
  state: {
    pagesEN: [],
    routesEN: [],
    pagesDE: [],
    routesDE: [],
    socialMedia: [],
    christmasFeatureList: [],
    language: "de-DE",
    isLoaded: true,
  },
  getters: {
    getPagesEN(state) {
      return state.pagesEN;
    },
    getRoutesEN(state) {
      return state.routesEN;
    },
    getPagesDE(state) {
      return state.pagesDE;
    },
    getRoutesDE(state) {
      return state.routesDE;
    },
    getSocialMedia(state) {
      return state.socialMedia;
    },
    getChristmasFeatureList(state) {
      return state.christmasFeatureList;
    },
    getLanguage(state) {
      return state.language;
    },
    getIsLoaded(state) {
      return state.isLoaded;
    },
    getShowSchedule(state) {
      return state.showSchedule;
    },
  },
  mutations: {
    setPagesEN(state, pages) {
      state.pagesEN = pages;
    },
    setRoutesEN(state, routes) {
      state.routesEN = routes;
    },
    setPagesDE(state, pages) {
      state.pagesDE = pages;
    },
    setRoutesDE(state, routes) {
      state.routesDE = routes;
    },
    setSocialMedia(state, socialMedia) {
      state.socialMedia = socialMedia;
    },
    setChristmasFeatureList(state, christmasFeatureList) {
      state.christmasFeatureList = christmasFeatureList;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setIsLoaded(state, isLoaded) {
      state.isLoaded = isLoaded;
    },
    setShowSchedule(state, showSchedule) {
      return (state.showSchedule = showSchedule);
    },
  },
});
